import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getPostDetail = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IGetPostDetail} = await request.get(
    `/api/v2/market/post?guid=${ctx.queryKey[1]}`,
  );
  return data;
};
